import { nanoid } from 'nanoid'
import type { TableData, TableRowData } from '../types/data'

export function rowFactory(data?: Record<string, TableData>): TableRowData {
  const id = nanoid()
  const row: TableRowData = {
    ...data,
    id,
    orientation: 'row',
    field: id,
    metadata: {},
    elementalTypeId: 0,
  }
  return row
}
